export default __webpack_public_path__ + "static/media/avatar_ali2.9bfb34cd.mp3";